import React from "react";
import ListConceptsContainer from "../../containers/ListConcepts";

const ListConceptsScreen = () => {
  return <ListConceptsContainer />;
};

export default ListConceptsScreen;
